import { Upload, message } from "antd";
import { useState } from "react";
import { CloudUpload } from "../assets";
import { API_URL } from "../config";
import { useAuth } from "../providers";

export const FileUploaderComponent = ({
  initialValues,
  onFileUploaded = (validUrls) => { },
  style = {},
  accept = ".pdf,.png,.jpg,.jpeg",
  multiple = true,
  maxFileSizeMB = 8,
}) => {
  const { token } = useAuth();
  const [uploadStatus, setUploadStatus] = useState("");

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const maxFileSize = maxFileSizeMB * 1024 * 1024;

      if (file.size > maxFileSize) {
        setUploadStatus(`❌ El archivo es demasiado grande (máx. ${maxFileSizeMB}MB)`);
        return;
      }
      if (!token) {
        setUploadStatus("❌ No hay token de autenticación");
        console.error("No token found");
        return;
      }

      const response = await fetch(`${API_URL}/images/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          // Nota: no pongas "Content-Type" con multipart/form-data, fetch lo maneja solo.
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        const uploadedUrl = data?.url || data?.fileUrl || data?.data?.url;
        if (!uploadedUrl) {
          setUploadStatus("❌ El servidor no retornó URL del archivo");
          message.error(`Subida sin URL de retorno: ${file.name}`);
          return null;
        }
        setUploadStatus("");
        return uploadedUrl;
      } else {
        if (response.status === 502) {
          setUploadStatus("❌ El servidor no pudo procesar el archivo (502). Intenta con un video más liviano o usa URL.");
          message.error("Servidor de carga no disponible o archivo demasiado pesado.");
          return null;
        }
        setUploadStatus(`❌ No se pudo subir el archivo (${response.status})`);
        message.error(`No se pudo subir el archivo: ${file.name}`);
        return null;
      }
    } catch (error) {
      setUploadStatus("❌ Error en la conexión");
      console.error("Error en la conexión", error);
      message.error(`Error al conectar con el servidor para: ${file.name}`);
      return null;
    }
  };

  return (
    <>
      <Upload.Dragger
        multiple={multiple}
        name="file"
        accept={accept}
        listType="picture"
        style={{
          ...style,
          width: "100%",
          border: "2px dashed #ccc",
        }}
        onChange={({ fileList }) => {
          const urls = fileList
            .map((f) => f.url)
            .filter((url) => typeof url === "string" && url);
          if (urls.length > 0) {
            onFileUploaded(urls);
          }
        }}
        customRequest={async ({ file, onSuccess, onError }) => {
          const url = await uploadFile(file);
          if (url) {
            onSuccess("ok");
            onFileUploaded([url]);
          } else {
            onError(new Error("Falló la subida"));
          }
        }}
      >
        <p className="ant-upload-drag-icon">
          <CloudUpload size={50} color={"red"} />
        </p>
        <p
          className="ant-upload-text"
          style={{ textAlign: "center", fontSize: "14px" }}
        >
          Arrastra tus archivos o
        </p>
        <p
          className="ant-upload-text"
          style={{ textAlign: "center", fontSize: "12px", color: "var(--color-secondary)" }}
        >
          da click para buscarlos
        </p>
      </Upload.Dragger>
      {uploadStatus && <p>{uploadStatus}</p>}
      {initialValues && initialValues.length > 0 && (
        <ul style={{ listStyle: "none", padding: 0, textAlign: "start" }}>
          {initialValues.map((url, index) => (
            <li key={index}>
              <a href={url} target="_blank" rel="noopener noreferrer">
                {url}
              </a>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
